import injectSheet from 'react-jss'

import Search from './Search'
import styles from './Search.styles'

export default injectSheet(styles)(Search)
